import React from 'react'
import View from '../../atoms/View'
import Space from '../../atoms/Space'
import Text from '../../atoms/TextNew'

interface Props {
  photo: string | null
  label1: string
  label2: string
  offer_hash_id: string
}

const ListLeftColumn = ({ photo, label1, label2, offer_hash_id }: Props): JSX.Element => {
  const photoWidth = photo === null ? 'w-22' : 'w-[112px]'
  return (
    <View className="flex">
      <Space x={4} />
      <img className={`${photoWidth} h-22 rounded-2 object-cover`} src={photo ?? '/assets/images/no_photo@x2.png'} />
      <Space x={6} />
      <View className="flex-col">
        <Text className="text-[20px] font-Bold">{label1}</Text>
        <Text className="text-xl">{label2?.toUpperCase()}</Text>
        <Space y={4} />
        <Text className="text-l">{offer_hash_id}</Text>
      </View>
    </View>
  )
}

export default ListLeftColumn
